const on_dev = false;
module.exports = {
  on_dev: on_dev,
  frontendURL:
    on_dev === true
      ? "http://localhost:3000/agro_epayment/"
      : "https://cloud.library.cmu.ac.th/agro_epayment/",

  // backendURL: "https://pay.arc.cmu.ac.th/v2/",
  backendURL: "https://cloud-3007.lib.cmu.ac.th/v2/",
  // digitalpayBackend: "https://pay.arc.cmu.ac.th/digital_payment/",
  digitalpayBackend: "https://cloud-3007.lib.cmu.ac.th/digital_payment/",
  authURL: "https://apis-3003.lib.cmu.ac.th/platform/oauth/",
  cookieName: "cmul-epayment-agro-cookie",
  fines_account_code: "4010704000001",
};
